import { ChipRadioGroup } from './ChipGroup'
import { ChipRadioGroupItem } from './ChipGroupItem'

export const Chip = {
  Group: ChipRadioGroup,
  GroupItem: ChipRadioGroupItem,
}
